<template>
    <div id="PropellingSuc">
      <div id="sucContent">
        <div class="col-md-24 text-center">
            <p class="titleSuc"><i class="suc icon el-icon-circle-check-outline"></i>提交成功</p>
            <p class="titleCont">推送申请已火速提交到运营大大手中，审核通过后，您将收到推送消息通知</p>
        </div>
        <div class="col-md-24 text-center">
          <el-button   type="primary"  class="submitSuc" @click="backIntention">返回意图列表</el-button>
          <el-button   type="primary"  class="submitSuc" @click="searchList">查看攻略</el-button>
        </div>
      </div>

    </div>
</template>

<script>
    export default {
        props: [],
      methods:{
        backIntention(){
          this.$router.push({path: `/intentionList?skillId=${this.$route.query.skillId}&online=${this.$route.query.online}`})
        },
        searchList(){
         // this.$store.dispatch("changeA",flag);
          this.$router.push({path: '/tutor/xggj_tssq'})

        }
      }
    }
</script>
<style rel="stylesheet/scss" lang="scss">
  #PropellingSuc {
    width: 100%;
    height: 100%;
    display: table;
     #sucContent{
       height:300px;
       width: 100%;
       text-align: center;
       display: table-cell;
       vertical-align:middle;
       .titleSuc{
           color:#387b21;
           font-size: 24px;
           margin-bottom: 45px;
           .suc{
               font-weight: 600;
               font-size: 26px;
               margin-right:10px;
           }
       }
       .titleCont{
         color:#646464;
         font-size: 14px;
         margin-bottom: 55px;
       }
       .submitSuc{
         border-radius:15px;
         width: 125px;
         margin-right: 15px;
       }

     }

  }
</style>



// WEBPACK FOOTER //
// src/components/skilloverview/PropellingSuc.vue